<template>
  <div class="container" :style="bgColorStyle">
    <!-- 所有组件的循环渲染 -->
    <Banner v-if="dataReady" :imgUrl="tplData.pageConfig.headImage"> </Banner>
    <!-- 主视图区域 -->
    <Main
      v-if="dataReady"
      :bgImgUrl="tplData.pageConfig.backgroundImage"
      :bgColor="tplData.pageConfig.backgroundColor"
    >
      <component
        v-for="compObj in flowComponentObjs"
        :key="compObj.id"
        :is="compObj.component"
        v-bind="compObj.props"
      ></component>
    </Main>
    <component
      v-for="footerCompObj in positionComponentObjs"
      :key="footerCompObj.id"
      :is="footerCompObj.component"
      v-bind="footerCompObj.props"
    ></component>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { flowComponents } from '../components/ComponentsBook';
import Main from '../components/Main';
import Banner from '../components/Banner';
import TokenIn from '@/components/mixins/tokenIn';
import { isRiskError } from '../utils';
import { getUrlParam } from '@/utils';
import { resolveComponents } from '../components/helper';
export default {
  mixins: [TokenIn],
  data() {
    return {
      flowComponentObjs: [],
      positionComponentObjs: []
    };
  },
  components: { Banner, Main },
  computed: {
    ...mapState('app', [
      'actData',
      'tplData',
      'activityCode',
      'position',
      'city_id',
      'metaInfo'
    ]),
    dataReady() {
      return this.tplData.pageConfig;
    },
    bgColorStyle() {
      if (
        this.tplData &&
        this.tplData.pageConfig &&
        this.tplData.pageConfig.backgroundColor
      ) {
        return {
          backgroundColor: this.tplData.pageConfig.backgroundColor
        };
      }
      return {};
    }
  },
  methods: {
    ...mapMutations('app', [
      'setPosition',
      'setCity_id',
      'setClient_ip',
      'setActivityCode',
      'setBusinessType'
    ]),

    ...mapMutations('global', ['set_env']),
    ...mapActions('app', ['fetchPageInfo', 'loadLocationData']),
    initComponents() {
      const [flowComponentObjs, positionComponentObjs] = resolveComponents(
        this.tplData.components,
        {
          actData: this.actData,
          actComponentLib: flowComponents,
          actComponentBuilder: this.actComponentBuilder
        }
      );
      console.log(
        flowComponentObjs,
        positionComponentObjs,
        'flowComponentObjs, positionComponentObjs'
      );
      this.positionComponentObjs = positionComponentObjs;
      this.flowComponentObjs = flowComponentObjs;
    },
    async initPageInfo() {
      if (getUrlParam('u')) {
        let userType = getUrlParam('u') === '1' ? 'user' : 'driver';
        this.set_env(userType);
      }
      if (getUrlParam('bl')) {
        this.setBusinessType(getUrlParam('bl'));
      }
      if (getUrlParam('code')) {
        this.setActivityCode(getUrlParam('code'));
      }
      await this.needLogin('', false);
      await this.loadLocationData(true);

      try {
        console.log('开始请求 pageinfo');
        await this.fetchPageInfo({
          locationInfo: {
            cityId: this.city_id,
            ...this.position
          },
          code: this.activityCode
        });
        document.title = this.tplData.pageConfig
          ? this.tplData.pageConfig.name
          : '邀请好友';
        console.log(this.actData, 'this.actData');
        let {
          shareTitle,
          shareDescription: shareContent,
          shareImage: shareUrl
        } = this.metaInfo.shareConfig;
        this.initShare({ shareUrl, shareTitle, shareContent });
      } catch (error) {
        // 命中风控处理
        if (isRiskError(error.ret)) {
          this.$router.replace({
            path: '/account_error',
            params: {
              type: 1 // 1:进入风控 2: 没有模版数据
            }
          });
          return;
        }
        this.$hll.toast(error && error.msg);
        return;
      }
    },
    actComponentBuilder(compData, actComponentRef) {
      const { componentDetail = {}, ...fields } = compData;
      return {
        ...compData,
        props: {
          ...fields,
          ...componentDetail,
          ...actComponentRef.props()
        },
        component: actComponentRef.component
      };
    },

    setTitle() {
      const actName = this.tplData.pageConfig && this.tplData.pageConfig.name;
      if (actName) {
        document.title = actName;
      }
    }
  },
  mounted() {},
  async created() {
    console.log('created+++++1');
    await this.initPageInfo();
    this.initComponents();
    console.log(this.metaInfo, 'metaInfo');
    this.$nextTick(() => {
      this.setTitle();
    });
  },
  watch: {
    $route() {
      this.setTitle();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 750px;
  padding-bottom: 230px;
}
</style>
